import { IState } from './ProductReceipts.reducer';

export interface IActions {
    [ProductReceiptsActionTypes.setProductReceiptContext]?: IState['ProductReceiptContext'];
    [ProductReceiptsActionTypes.setProductReceipt]?: IState['ProductReceipt'];
    [ProductReceiptsActionTypes.setLineNumber]?: IState['LineNumber'];
    [ProductReceiptsActionTypes.setSummaryPanelData]?: IState['SummaryPanelData'];
    [ProductReceiptsActionTypes.setPreventChangeStatus]?: IState['PreventChangeStatus'];
    [ProductReceiptsActionTypes.setIsChangeStatusDisabled]?: IState['IsChangeStatusDisabled'];
    [ProductReceiptsActionTypes.setProductReceiptsLookupPanelOpen]?: IState['ProductReceiptsLookupPanelOpen'];
    [ProductReceiptsActionTypes.setLHSFocusField]?: IState['LHSFocusField'];
}

export enum ProductReceiptsActionTypes {
    setProductReceiptContext = 'setProductReceiptContext',
    setProductReceipt = 'setProductReceipt',
    setLineNumber = 'setLineNumber',
    setSummaryPanelData = 'setSummaryPanelData',
    setIsChangeStatusDisabled = 'setIsChangeStatusDisabled',
    setPreventChangeStatus = 'setPreventChangeStatus',
    setProductReceiptsLookupPanelOpen = 'setProductReceiptsLookupPanelOpen',
    setLHSFocusField = 'setLHSFocusField'
}
